export const VERIFICATION_PROCESS_MODAL_ID = 'VerificationProcessID';
